import { GremlinNode } from './gremlinNode';

export class GremlinLink extends GremlinNode {
  source: number;
  target: number;
}
